import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import type { ChangeWheelsView } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { defineMessages, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { propertiesOf } from "src/common/property"
import type { ChangeCustomWheelsFormProps } from "./ChangeCustomWheelsFormProps"
import type { ChangeCustomWheelsProps } from "./ChangeCustomWheelsProps"

const messages = defineMessages({
	wheelsName: {
		defaultMessage: "Wheels Name",
		id: "equipment.wheels.name",
	},
	wheelTags: {
		defaultMessage: "Wheel Tags",
		id: "equipment.wheels.tags",
	},
})

const formProperties = propertiesOf<ChangeCustomWheelsFormProps>()

export const useChangeCustomWheelsProps: (props: { view: ChangeWheelsView["custom"] }) => ChangeCustomWheelsProps = ({
	view,
}) => {
	const { formatDisplayName, formatMessage } = useIntl()
	const { availableLocales } = useDealerContext()
	return useMemo(
		() => ({
			name: availableLocales.map((languageTag) => ({
				label: `${formatMessage(messages.wheelsName)} - ${formatDisplayName(languageTag, {
					type: "language",
				})}`,
				name: formProperties.name._get(languageTag)._path,
				required: true,
				type: "text",
				validate: (value: string | number) =>
					value.toString() !== value.toString().toUpperCase() ||
					formatMessage(commonMessages.onlyCapitalLetters),
			})),
			tags: {
				label: formatMessage(messages.wheelTags),
				name: formProperties.tags._path,
				options: view.tags.options.map(({ key, name }) => ({
					label: name,
					value: key,
				})),
				required: true,
			},
		}),
		[availableLocales, formatDisplayName, formatMessage, view.tags.options],
	)
}
